import React, { Component } from 'react';

import styled from 'styled-components';
import ds from 'designsystem';

/* eslint-disable react/prop-types */

const ImgModalBox = styled.div`
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);;
    position: fixed;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
`;

const CloseIcon = styled.a`
    display: block;
    position: absolute;
    width: 25px;
    height: 25px;
    top: 15px;
    right: 15px;
    cursor: pointer;
    &:before, &:after {
        display: block;
        content: '';
        position: absolute;
        right: 12px;
        height: 25px;
        width: 2px;
        background-color: ${ds.brand('background')};
    };
    &:before {
        transform: rotate(45deg);
    };
    &:after {
        transform: rotate(-45deg);
    }
`;

const ImageWrapper = styled.img`
    display: block;
    max-width: 100%;
    max-height: 100%;
    cursor: pointer;
`;

export default class ImgModal extends Component {
  constructor(props) {
    super(props);
  }

  closeModal = () => {
      this.props.closeModal();
  }

  render() {
      const {image, alt} = this.props
    return (
        <ImgModalBox>
            <ImageWrapper className='Image' src={image} alt={alt} onClick={this.closeModal}/>
            <CloseIcon onClick={this.closeModal} />
        </ImgModalBox>
      );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/ImgModal/ImgModal.jsx